module.exports = __webpack_public_path__ + "img/alert_buy.fae364d9.svg";